import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";
import "../../../styles/home1.css";

const monthlyPurchaseData = Array.from({length:15},(_,i)=>({
  day:i+1,
  value:Math.floor(Math.random()*50)+40
}));

export default function PurchaseAnalysisChart(){

return(

<div className="card shadow-sm border-0 h-100">
<div className="card-body">

<h6 className="fw-bold mb-3">Quality Purchase Analysis</h6>

<div style={{width:"100%",height:200}}>
<ResponsiveContainer>

<BarChart data={monthlyPurchaseData} barGap={4}>

<CartesianGrid strokeDasharray="3 3" opacity={0.3}/>
<XAxis dataKey="day"/>
<YAxis/>

<Bar dataKey="value" fill="#1976d2" radius={[4,4,0,0]} barSize={15}/>

</BarChart>

</ResponsiveContainer>
</div>

</div>
</div>

);
}